import { styled } from 'troyfe'

const messageDrawerDiv = styled.div`
  .messageDrawerTop {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E2E2E2;

    .messageDrawerTopLeft {
      display: flex;
      align-items: center;

      .list {
        padding: 0 40px;
        font-size: 18px;
        font-weight: 500;
        color: #1B1B1D;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .text {
          padding-top: 23px;
        }

        .bar {
          width: 40px;
          height: 4px;
          border-radius: 2px;
        }
      }

      .active {
        .text {
          color: #44BB55;
        }

        .bar {
          width: 40px;
          height: 4px;
          background: #44BB55;
          border-radius: 2px;
        }
      }
    }

    .childrenDrawerRight {
      text-align: center;
      width: 100%;
      font-size: 18px;
      font-weight: 500;
      color: #1B1B1D;
    }

    .messageDrawerRight {
      min-width: 16px;
      height: 16px;
      margin-right: 32px;
      cursor: pointer;

      .forkImg {
        width: 16px;
        height: 16px;
      }
    }
  }

  .messageDrawerContent {
    height: calc(100vh - 152px);
    overflow-x: hidden;

    .contentList {
      display: flex;
      width: calc(100% - 40px);
      margin: 0 20px;
      padding: 20px 0;
      border-bottom: 1px solid #E2E2E2;

      .listLeft {
        width: 10px;
        height: 10px;
        background: #999999;
        margin-top: 5px;
        border-radius: 50%;
      }

      .read {
        background: #FF513D;
      }

      .greenDot {
        background: #44BB55;
      }

      .listRight {
        padding-left: 10px;

        .listTitle {
          display: flex;
          font-size: 14px;
          font-weight: 400;
          color: #1B1B1D;
          line-height: 24px;
          margin-bottom: 10px;

          .black {
            color: #1B1B1D;
          }

          .gray {
            color: #666666;
          }

          .green {
            color: #44BB55;
          }
        }

        .listTime {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
        }
      }
    }

    .more {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 24px;
      text-align: center;
      cursor: pointer;
      margin-top: 20px;
    }
  }

  .all {
    height: 80px;
    line-height: 80px;
    border-top: 1px solid #E2E2E2;
    font-size: 16px;
    font-weight: 400;
    color: #44BB55;
    padding-left: 40px;
    cursor: pointer;
  }

  .childrenDrawerContent {
    .childrenDrawerTitle {
      text-align: center;
      font-size: 24px;
      font-weight: 500;
      color: #1B1B1D;
      line-height: 32px;
      margin-top: 40px;
    }

    .childrenDrawerTips {
      display: flex;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-top: 16px;
      margin-bottom: 40px;

      .tipsLeft {
        margin-right: 80px;
      }
    }

    .childrenDrawerContentList {
      padding: 0 40px;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
  }
`

export default messageDrawerDiv